package one.healthium.log_food.di

import one.healthium.log_food.data.AppFoodRepository
import one.healthium.log_food.data.FoodMapper
import one.healthium.log_food.data.FoodPreloadContent
import one.healthium.log_food.domain.FoodRepository
import one.healthium.log_food.ui.add_food.AddFoodViewModel
import one.healthium.log_food.ui.find_food.FindFoodViewModel
import one.healthium.log_food.ui.mappers.FoodUiMapper
import org.koin.core.module.dsl.viewModelOf
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val logFoodModule = module {
    singleOf(::AppFoodRepository) bind FoodRepository::class
    factoryOf(::FoodMapper)
    singleOf(::FoodPreloadContent)

    viewModelOf(::FindFoodViewModel)
    viewModelOf(::AddFoodViewModel)

    factoryOf(::FoodUiMapper)
}